<template>
  <div
    class="leftside-menu"
    style="background-color: white; color: #4b5675"
    :style="backgroundColor"
  >
    <!-- LOGO -->
    <a
      href=""
      class="logo text-center logo-light"
      style="background-color: white !important"
    >
      <span class="logo-lg">
        <h4 style="color: black">{{ $store.state.company_name }}</h4>
      </span>
    </a>

    <div class="h-100" id="leftside-menu-container" data-simplebar>
      <!--- Sidemenu -->
      <ul class="side-nav">
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.personal')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #6c5ce7">
            <span style="font-size: 18px"> میزکار</span>
          </a>
        </li>
        <li class="side-nav-item">
          <router-link
            :to="{ name: 'dashboard' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-architecture-alt mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span> میزکار من </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.orders')"
        >
          <router-link
            :to="{ name: 'orders' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-help-robot mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span>
              پروژه‌ها<span
                v-if="$store.state.orders != 0"
                style="color: #6c5ce7"
                >({{ $store.state.orders }})</span
              >
            </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.employeeweek')"
        >
          <router-link
            :to="{ name: 'employeeWeek', params: { id: getId } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-engineer mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span>
              امور محوله
              <span v-if="$store.state.daily_ords != 0" style="color: #4b5675"
                >({{ $store.state.daily_ords }})</span
              ></span
            >
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.bills')"
        >
          <router-link
            :to="{ name: 'bills' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-money-bag mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span> فیش حقوقی </span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link
            :to="{ name: 'my_requests' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-pen-alt-1 mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span> درخواست‌های من </span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link
            :to="{ name: 'requests_manager' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-pen-alt-1 mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span> مدیریت درخواست‌ها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.times')"
        >
          <router-link
            :to="{ name: 'times' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-meeting-add mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span> ساعت کاری </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.files')"
        >
          <router-link
            :to="{ name: 'files' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-search-folder mx-0"
              style="font-size: 25px; color: #6c5ce7"
            ></i>
            <span> مخزن فایل </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.content')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #0652dd">
            <span style="font-size: 18px"> ماژول تامین محتوا</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.directs')"
        >
          <router-link
            :to="{ name: 'directs' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-instagram mx-0"
              style="font-size: 25px; color: #0652dd"
            ></i>
            <span> ثبت گزارش مارکتینگ </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.groups')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #1abc9c">
            <span style="font-size: 18px"> ماژول مکاتبات</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.envelopes')"
        >
          <router-link
            :to="{ name: 'envelopes' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-envelope mx-0"
              style="font-size: 25px; color: #1abc9c"
            ></i>
            <span> نامه‌های من </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.envelopes_all')"
        >
          <router-link
            :to="{ name: 'envelopes_all' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-envelope mx-0"
              style="font-size: 25px; color: #1abc9c"
            ></i>
            <span> همه نامه‌ها </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.groups')"
        >
          <router-link
            :to="{ name: 'groups' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-comment mx-0"
              style="font-size: 25px; color: #1abc9c"
            ></i>
            <span>
              اتاق‌های گفتگو
              <span v-if="$store.state.envelopes != 0" style="color: #4b5675"
                >({{ $store.state.envelopes }})</span
              ></span
            >
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.emails')"
        >
          <router-link
            :to="{ name: 'emails' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-email mx-0"
              style="font-size: 25px; color: #1abc9c"
            ></i>
            <span> ارسال و دریافت ایمیل</span>
          </router-link>
        </li>
        <li
          class="side-nav-item d-none"
          v-if="$store.state.permissions.includes('sidebar.voip')"
        >
          <router-link
            :to="{ name: 'voip' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-headphone-alt mx-0"
              style="font-size: 25px; color: #1abc9c"
            ></i>
            <span> ویپ</span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.charts')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #3c6382">
            <span style="font-size: 18px"> ماژول گزارشات</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.chartscreate')"
        >
          <router-link
            :to="{ name: 'chartsCreate' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-pie-alt mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> گزارشات تولید </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.chartssell')"
        >
          <router-link
            :to="{ name: 'chartsSell' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-arrows-axis mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> گزارشات فروش </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.chartsstore')"
        >
          <router-link
            :to="{ name: 'chartsStore' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-radar-graph mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> گزارشات انبار </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.chartstarabari')"
        >
          <router-link
            :to="{ name: 'chartsTarabari' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-growth mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> گزارشات ترابری </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.chartmali')"
        >
          <router-link
            :to="{ name: 'chartsMali' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-line-alt mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> گزارشات مالی </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.program')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #f1c40f">
            <span style="font-size: 18px"> ماژول برنامه ریزی</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ordersadmins')"
        >
          <router-link
            :to="{ name: 'ordersAdmin' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-dashboard-web mx-0"
              style="font-size: 25px; color: #f1c40f"
            ></i>
            <span>
              میزکار پروژه‌ها
              <span v-if="$store.state.all_ords != 0" style="color: #f1c40f"
                >({{ $store.state.all_ords }})</span
              ></span
            >
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ordersadmins')"
        >
          <router-link
            :to="{ name: 'map' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-map mx-0"
              style="font-size: 25px; color: #f1c40f"
            ></i>
            <span> وضعیت کلی پروژه‌ها </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ordersadmins')"
        >
          <router-link
            :to="{ name: 'ordersAdminList' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-dashboard-web mx-0"
              style="font-size: 25px; color: #f1c40f"
            ></i>
            <span>
              لیست کارها
              <span v-if="$store.state.all_ords != 0" style="color: #f1c40f"
                >({{ $store.state.all_ords }})</span
              ></span
            >
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ordersmanager')"
        >
          <router-link
            :to="{ name: 'ordersManager' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-architecture-alt mx-0"
              style="font-size: 25px; color: #f1c40f"
            ></i>
            <span>
              واحد ارجاع
              <span v-if="$store.state.section_ords != 0" style="color: #f1c40f"
                >({{ $store.state.section_ords }})</span
              ></span
            >
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ordersmanager')"
        >
          <router-link
            :to="{ name: 'ordersManagerList' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-architecture-alt mx-0"
              style="font-size: 25px; color: #f1c40f"
            ></i>
            <span>
              لیست ارجاع
              <span v-if="$store.state.section_ords != 0" style="color: #f1c40f"
                >({{ $store.state.section_ords }})</span
              ></span
            >
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.dailychart')"
        >
          <router-link
            :to="{ name: 'dailyChart' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-ui-calendar mx-0"
              style="font-size: 25px; color: #f1c40f"
            ></i>
            <span> برنامه روزانه </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.create')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #ff7979">
            <span style="font-size: 18px"> ماژول تولید</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.orderscreate')"
        >
          <router-link
            :to="{ name: 'ordersAdmin' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-plus mx-0"
              style="font-size: 25px; color: #ff7979"
            ></i>
            <span> ثبت سفارشات</span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.projects')"
        >
          <router-link
            :to="{ name: 'projects' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-calculations mx-0"
              style="font-size: 25px; color: #ff7979"
            ></i>
            <span> فرآیندها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.draftsums')"
        >
          <router-link
            :to="{ name: 'draftsums' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-test-tube-alt mx-0"
              style="font-size: 25px; color: #ff7979"
            ></i>
            <span> فرمول تولید </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.mali')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #009432">
            <span style="font-size: 18px"> ماژول مالی</span>
          </a>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.transactions')"
        >
          <router-link
            :to="{ name: 'transactions' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-dollar-true mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> تراکنش‌های مالی </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.receipts')"
        >
          <router-link
            :to="{ name: 'receipts' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-law-document mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> صدور سند حسابداری </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.balance')"
        >
          <router-link
            :to="{ name: 'balance' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-coins mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> ترازنامه </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.tahods')"
        >
          <router-link
            :to="{ name: 'tahods' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-dollar-plus mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> چک‌ها و تعهدات </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.debts')"
        >
          <router-link
            :to="{ name: 'debts' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-money mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> وام کارمندان </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.alltimes')"
        >
          <router-link
            :to="{ name: 'all_times' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-meeting-add mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> ساعت‌های کاری </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.allbills')"
        >
          <router-link
            :to="{ name: 'allBills' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-bill-alt mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> محاسبات حقوق و دستمزد </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.contracts')"
        >
          <router-link
            :to="{ name: 'contracts' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-law-document mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> قراردادهای کار </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.hesabs')"
        >
          <router-link
            :to="{ name: 'hesabs' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-bank-alt mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> حساب‌ها</span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.cheques')"
        >
          <router-link
            :to="{ name: 'cheques' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-fountain-pen mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> دسته‌چک‌ها</span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
      
        >
          <router-link
            :to="{ name: 'social-insurances' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-certificate-alt-1 mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> بیمه‌های تامین اجتماعی </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.setting_mali')"
        >
          <router-link
            :to="{ name: 'setting_mali' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-automation mx-0"
              style="font-size: 25px; color: #009432"
            ></i>
            <span> تنظیمات مالی </span>
          </router-link>
        </li>

        <!-- ماژول سئو -->
        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.seo')"
        >
          <a class="side-nav-link py-1 ps-3" style="color: #7952b3">
            <span style="font-size: 18px"> ماژول سئو</span>
          </a>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.seo')"
        >
          <router-link
            :to="{ name: 'seo' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-growth mx-0"
              style="font-size: 25px; color: #7952b3"
            ></i>
            <span> مدیریت سئو </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.pass')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #22a6b3">
            <span style="font-size: 15px"> ماژول خدماتِ پس‌از‌فروش</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.afters')"
        >
          <router-link
            :to="{ name: 'afters' }"
            class="side-nav-link py-1 pe-0"
            style="color: #4b5675; font-size: 14px"
          >
            <i
              class="icofont-live-support mx-0"
              style="font-size: 25px; color: #22a6b3"
            ></i>
            <span>پروژه‌های خدماتِ پس‌از‌فروش</span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.bimes')"
        >
          <router-link
            :to="{ name: 'bimes' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-certificate-alt-1 mx-0"
              style="font-size: 25px; color: #22a6b3"
            ></i>
            <span> بیمه محصولات </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.garantis')"
        >
          <router-link
            :to="{ name: 'garantis' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-shield-alt mx-0"
              style="font-size: 25px; color: #22a6b3"
            ></i>
            <span> گارانتی محصولات </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.problems')"
        >
          <router-link
            :to="{ name: 'problems' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-exclamation-tringle mx-0"
              style="font-size: 25px; color: #22a6b3"
            ></i>
            <span> ایرادات محصولات </span>
          </router-link>
        </li>

        <li
          class="side-nav-item mt-3"
          v-if="$store.state.permissions.includes('sidebar.sell')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #f0932b">
            <span style="font-size: 18px"> ماژول فروش</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.customers')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 1 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-users-social mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span>
              مشتریان
              <span v-if="$store.state.customers != 0" style="color: #f0932b"
                >({{ $store.state.customers }})</span
              ></span
            >
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('users.store_customer')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 7 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-users-social mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> ثبت مشتری </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.factors')"
        >
          <router-link
            :to="{ name: 'factors' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-file-alt mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> صدور فاکتور </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sell_contracts')"
        >
          <router-link
            :to="{ name: 'sell_contracts' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-law-document mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> قراردادهای فروش </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.setting_sell')"
        >
          <router-link
            :to="{ name: 'setting_sell' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-automation mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> تنظیمات فروش </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sell')"
        >
          <router-link
            :to="{ name: 'crmDashboard' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-line-alt mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> داشبورد CRM </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sell')"
        >
          <router-link
            :to="{ name: 'crmFlows' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-chart-flow mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>

            <span> مسیرها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sell')"
        >
          <!-- <router-link
            :to="{ name: 'crmCustomerFlows' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-play-alt-2 mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> اجرای مسیرها </span>
          </router-link> -->
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sell')"
        >
          <router-link
            :to="{ name: 'crmTasks' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-tasks mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> تسک‌ها </span>
            <span
              v-if="$store.state.crm_pending_tasks"
              class="badge bg-danger ms-1"
            >
              {{ $store.state.crm_pending_tasks }}
            </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sell')"
        >
          <router-link
            :to="{ name: 'crmActivities' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-handshake-deal mx-0"
              style="font-size: 25px; color: #f0932b"
            ></i>
            <span> تعاملات </span>
          </router-link>
        </li>

        <li
          class="side-nav-item mt-3"
          v-if="$store.state.permissions.includes('sidebar.ravan')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #f1416c">
            <span style="font-size: 18px"> ماژول سلامت روان</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ravansedit')"
        >
          <router-link
            :to="{ name: 'ravansEdit' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-stethoscope-alt mx-0"
              style="font-size: 25px; color: #f1416c"
            ></i>
            <span> تشکیل پرونده اولیه </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.ravans')"
        >
          <router-link
            :to="{ name: 'ravans' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-heart-beat-alt mx-0"
              style="font-size: 25px; color: #f1416c"
            ></i>
            <span> جلسات روانشناسی </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.store')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #84817a">
            <span style="font-size: 18px"> ماژول انبار</span>
          </a>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.stores')"
        >
          <router-link
            :to="{ name: 'stores' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-fork-lift mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> انبارها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.rigs')"
        >
          <router-link
            :to="{ name: 'rig_floor_tags' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-drill mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> تجهیزات تولید </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.drafts')"
        >
          <router-link
            :to="{ name: 'drafts' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-barcode mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> حواله‌ها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.allkalas')"
        >
          <router-link
            :to="{ name: 'allKalas' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-drill mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> همه کالاها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.odats')"
        >
          <router-link
            :to="{ name: 'odats' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-ui-reply mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> عودت کالا </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.services')"
        >
          <router-link
            :to="{ name: 'storeServices' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-tools-bag mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> خدمات برون‌سپاری </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.done_users')"
        >
          <router-link
            :to="{ name: 'doneUsers' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-cart-alt mx-0"
              style="font-size: 25px; color: #84817a"
            ></i>
            <span> جمع‌آوری کالاها </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.other')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #ff7f50">
            <span style="font-size: 18px"> ماژول کنترل کیفی</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.forms')"
        >
          <router-link
            :to="{ name: 'forms' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-prescription mx-0"
              style="font-size: 25px; color: #ff7f50"
            ></i>
            <span> فرم‌های کنترل‌ کیفی </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.drafts')"
        >
          <router-link
            :to="{ name: 'foms' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-prescription mx-0"
              style="font-size: 25px; color: #ff7f50"
            ></i>
            <span> کنترل کیفی انبار </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.tadarokat')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #0be881">
            <span style="font-size: 18px"> ماژول تدارکات</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.kasri')"
        >
          <router-link
            :to="{ name: 'drafts' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-abacus mx-0"
              style="font-size: 25px; color: #0be881"
            ></i>
            <span> گزارش کسری </span>
          </router-link>
        </li>

        <li
          class="side-nav-item pt-3"
          v-if="$store.state.permissions.includes('sidebar.manage')"
        >
          <a href="#" class="side-nav-link py-1 ps-3" style="color: #3c6382">
            <span style="font-size: 18px"> ماژول اطلاعات پایه</span>
          </a>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.employees')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 2 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-workers-group mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> کارمندان </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.fund_tags')"
        >
          <router-link
            :to="{ name: 'fundTags' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-fast-food mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> دسته‌بندی تنخواه </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sections')"
        >
          <router-link
            :to="{ name: 'sections' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-industries-5 mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> واحدها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.folder_templates')"
        >
          <router-link
            :to="{ name: 'folder_templates' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-folder mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> پوشه‌بندی مخزن فایل </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.products')"
        >
          <router-link
            :to="{ name: 'products' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-rocket-alt-2 mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> محصولات </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.products')"
        >
          <router-link
            :to="{ name: 'services' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-wrench mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> خدمات </span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.tarafs')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 4 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-industries mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> طرف‌حساب‌ها</span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.sarmayegozars')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 3 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-handshake-deal mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span>سرمایه‌گذارها</span>
          </router-link>
        </li>

        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.mihmans')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 5 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-people mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> مهمان‌ها</span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.hamkars')"
        >
          <router-link
            :to="{ name: 'users', query: { tr: 6 } }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-business-man-alt-1 mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> همکاران </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="
            $store.state.permissions.includes('sidebar.personal_access_tokens')
          "
        >
          <router-link
            :to="{ name: 'personal_access_tokens' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-laptop mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> نشست‌ها</span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.setting_general')"
        >
          <router-link
            :to="{ name: 'setting_general' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-automation mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> تنظیمات عمومی </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.roles')"
        >
          <router-link
            :to="{ name: 'roles' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-company mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> نقش‌ها </span>
          </router-link>
        </li>
        <li
          class="side-nav-item"
          v-if="$store.state.permissions.includes('sidebar.permissions')"
        >
          <router-link
            :to="{ name: 'permissions' }"
            class="side-nav-link py-1"
            style="color: #4b5675; font-size: 16px"
          >
            <i
              class="icofont-ui-password mx-0"
              style="font-size: 25px; color: #3c6382"
            ></i>
            <span> دسترسی‌ها </span>
          </router-link>
        </li>
      </ul>

      <!-- End Sidebar -->

      <div class="clearfix"></div>
    </div>
    <!-- Sidebar -left -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "getPage",
      "getId",
      "getAllOrds",
      "getSectionOrds",
      "getOrders",
      "getCustomers",
      "getDailyOrds",
    ]),
    backgroundColor() {
      if (screen.width < 768) {
        return "background-color:#ecf0f1 !important";
      } else {
        return "background-color:white !important";
      }
    },
  },
  created() {
    this.setPage("dashboard");
  },
  methods: {
    ...mapActions(["setPage"]),
  },
};
</script>
